import { CustomError } from 'utils/customError'

interface IConversationErrorConstructor {
  name: string
  message: string
  statusCode?: number | undefined
}
export class ConversationError extends Error {
  readonly name: string
  readonly message: string
  readonly statusCode: number

  constructor({ name, message, statusCode }: IConversationErrorConstructor) {
    super(message)
    this.name = name
    this.statusCode = statusCode
  }
}

export class ForbiddenError extends CustomError {
  constructor(apiPath: string, originalError: any) {
    let title = 'Fitur ini segera hadir'
    let description =
      'Saat ini kamu belum mendapatkan akses untuk fitur ini karena masih dalam proses uji coba'
    super({ title, description, apiPath, originalError })
  }
}
